const WelcomeCardsMixins = {
    data() {
        return {
            titles: [
                {
                    title: 'Assetto Corsa',
                    link: 'assetto-corsa',
                },
                {
                    title: 'BeamNG Drive',
                    link: 'beamng-drive',
                },
            ]
        }
    }
}

export default WelcomeCardsMixins